import type { QueryHookOptions } from "@apollo/client"
import { useQuery } from "@apollo/client"
import query from "@/v2-backoffice-client/layer/counts/layer.counts.query.gql"
import type {
  LayerCountsQuery,
  LayerCountsQueryVariables,
} from "@/v2-backoffice-client/layer/counts/__types__/layer.counts.query"

type Options = QueryHookOptions<LayerCountsQuery, LayerCountsQueryVariables>

export function useLayerCountsQuery(options?: Options) {
  return useQuery<LayerCountsQuery, LayerCountsQueryVariables>(query, options)
}
